<template>
  <div v-if="agreement">
    <div class="page-title mt-5">
      <mdb-input label="제목" v-model="agreement.title"/>
    </div>
    <Editor api-key="bb6a9ok4gca5sz21rpraocwpvxacglub7ukxmzxm8plvzlkz" v-model="agreement.content" :init="editorInit"/>
    <div class="text-center">
      <mdb-btn icon="undo" class="py-2" @click="$router.back()">돌아가기</mdb-btn>
      <mdb-btn icon="save" class="py-2" color="primary" @click="onSave()">저장</mdb-btn>
    </div>
  </div>
</template>
<script>
import { } from 'mdbvue';
import Editor from '@tinymce/tinymce-vue';
import { editorInit } from '@/views/common/config.js';
export default {
  name: 'StaffAgreementEdit',
  components: { Editor },
  props: [],
  data: () => ({
    TAG: 'StaffAgreementEdit :',
    agreement: undefined,
    editorInit: editorInit
  }),
  computed: {
    _id () { return this.$route.params._id }
  },
  methods: {
    async onSave (_id) {
      if (!this.agreement.title) {
        return alert('제목을 입력하세요.')
      }
      // this.agreement = await this.agreement.save()
    }
  },
  async created () {
    if (this._id === 'new') {
      this.agreement = this.$Agreement.create()
    } else {
      this.agreement = await this.$Agreement.get(this._id)
    }
  }
}
</script>
